import actions from "./actions";

const initState = {
  waiters: [],
  waitersTurnOver: [],
  waiterTurnOver: [],
  loading: false,
};

export default function waitersReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_WAITERS_SUCCESS:
      return {
        ...state,
        waiters: action.waiters,
      };

    case actions.FILTER_BY_WAITERS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.FILTER_BY_WAITERS_SUCCESS:
      return {
        ...state,
        waitersTurnOver: action.waitersTurnOver,
        loading: false,
      };

    default:
      return state;
  }
}
